import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=87d843c4&scoped=true"
var script = {}
import style0 from "./footer.vue?vue&type=style&index=0&id=87d843c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_css-loader@6.11.0_webpack@5.111.1_postcss@8_cee907f41370107bcc48efa63f51a283/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87d843c4",
  null
  
)

export default component.exports